import React from 'react';
import './initial-route.scss';
import Spinner from '~/components/base/Spinner';

type Props = {
    // TODO add props here
}

export default function InitialRouteScreen(_: Props): JSX.Element {
    return (
        <div className='initial-route'>
            <Spinner size={30} />
        </div>
    );
}
